/*
 * glasstat-swatch-groups.js  -  2026-08-21, readout added 2026-08-26
 * ---------------------------------------------------------------------------
 * PROTOTYPE LAYER. Two jobs, neither of which edits sections/product-100.liquid:
 *
 *   1. Sorts the border-tile swatches into three labelled groups
 *      (Solid Colors / Iridescent / Metallic).
 *   2. Names the tile under the cursor, in one line above each picker.
 *
 * Both read the name already in each swatch's title attribute, e.g.
 *   "Aruba - METALLIC", "Bel Air Blue - IRRIDIZED", "Alpine"
 * so no new data is required. Those names come from the Bonify shop metafield
 * custom_fields.tile_name_1 and are printed VERBATIM - David's call on
 * 2026-08-26 to leave them exactly as they are, suffixes and all.
 *
 * ---------------------------------------------------------------------------
 * WHY THE READOUT SHOWS HOVER ONLY, NEVER THE SELECTION
 *
 * The theme's own <h4> already appends the chosen tile to the question:
 *   before click ->  "Choose Tile Color #1:"
 *   after click  ->  "Choose Tile Color #1: Chartrues"
 * but it does NOT change on hover. Verified by rendering the page.
 *
 * So the heading owns the RECORD of what is chosen, and this readout owns the
 * live PREVIEW of what is under the cursor. If the readout also echoed the
 * selection the same name would sit on screen twice, three lines apart.
 *
 * Idle state keeps a short hint rather than going blank, so the line has a
 * reason to exist before the customer discovers hovering. Touch devices get
 * no hover at all - there the heading alone does the job, which is correct.
 * ---------------------------------------------------------------------------
 *
 * Swatches are MOVED with appendChild, never cloned or rebuilt via innerHTML.
 * Moving a node preserves its event listeners, so the existing click handler
 * (which writes the tile name into properties[Tile Color #N]) keeps working.
 *
 * The readout is inserted as a SIBLING immediately before .cp-select, never
 * inside it, so no existing selector that targets the picker's children can
 * be thrown off by an extra element.
 *
 * SELECTION INDICATOR: the theme's own indicator sets opacity on an
 * <i class="fa fa-check"> and stops working once the anchors are nested, so
 * this file adds its own .gt-selected class instead, scoped per picker. That
 * is also clearer than a small checkmark at 48px.
 *
 * Remove this file, its <script> tag in theme.liquid, and the matching CSS
 * blocks in custom.css once product-100.liquid is rebuilt in Pass 4.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var GROUPS = [
    { key: 'solid',      label: 'Solid Colors' },
    { key: 'iridescent', label: 'Iridescent'   },
    { key: 'metallic',   label: 'Metallic'     }
  ];

  var HINT = 'Point at a tile to see its color name';

  function finishOf(text) {
    if (/metallic/i.test(text)) return 'metallic';
    if (/irr?idized|iridescent/i.test(text)) return 'iridescent';
    return 'solid';
  }

  function nameOf(a) {
    return (a.getAttribute('title') || a.getAttribute('data-name') || '').trim();
  }

  function closestAnchor(node, container) {
    while (node && node !== container) {
      if (node.tagName === 'A') return node;
      node = node.parentNode;
    }
    return null;
  }

  function wireSelection(container) {
    container.addEventListener('click', function (e) {
      var a = closestAnchor(e.target, container);
      if (!a) return;
      var all = container.getElementsByTagName('a');
      for (var i = 0; i < all.length; i++) all[i].className = all[i].className.replace(/\s*gt-selected/g, '');
      a.className = (a.className + ' gt-selected').trim();
    });
  }

  function buildReadout(container) {
    if (!container.parentNode) return null;

    var readout = document.createElement('div');
    readout.className = 'gt-swatch-readout';

    var value = document.createElement('span');
    value.className = 'gt-swatch-readout__value gt-is-hint';
    value.textContent = HINT;

    readout.appendChild(value);
    container.parentNode.insertBefore(readout, container);

    container.addEventListener('mouseover', function (e) {
      var a = closestAnchor(e.target, container);
      if (!a) return;
      var n = nameOf(a);
      if (!n) return;
      value.textContent = n;
      value.className = 'gt-swatch-readout__value';
    });

    container.addEventListener('mouseleave', function () {
      value.textContent = HINT;
      value.className = 'gt-swatch-readout__value gt-is-hint';
    });

    return readout;
  }

  function groupContainer(container) {
    if (container.getAttribute('data-gt-grouped') === '1') return;

    var swatches = [];
    var child = container.firstElementChild;
    while (child) {
      if (child.tagName === 'A') swatches.push(child);
      child = child.nextElementSibling;
    }

    // Only act on a full picker. If the markup is not what we expect, leave it alone.
    if (swatches.length < 6) return;

    var buckets = { solid: [], iridescent: [], metallic: [] };
    swatches.forEach(function (a) {
      buckets[finishOf(nameOf(a))].push(a);
    });

    var frag = document.createDocumentFragment();

    GROUPS.forEach(function (g) {
      var items = buckets[g.key];
      if (!items.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'gt-swatch-group gt-swatch-group--' + g.key;

      var label = document.createElement('div');
      label.className = 'gt-swatch-group__label';
      label.textContent = g.label;

      var count = document.createElement('span');
      count.className = 'gt-swatch-group__count';
      count.textContent = items.length;
      label.appendChild(count);

      var row = document.createElement('div');
      row.className = 'gt-swatch-group__items';
      items.forEach(function (a) { row.appendChild(a); });

      wrap.appendChild(label);
      wrap.appendChild(row);
      frag.appendChild(wrap);
    });

    container.appendChild(frag);
    container.setAttribute('data-gt-grouped', '1');
    wireSelection(container);
    buildReadout(container);
  }

  function run() {
    var containers = document.querySelectorAll('.cp-select');
    for (var i = 0; i < containers.length; i++) groupContainer(containers[i]);
  }

  function schedule() { setTimeout(run, 250); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
})();
